import { useSelector } from 'react-redux';
import { selectActiveAccountId } from 'store/session/index';

export function useIsGuest() {
  return useSelector(selectActiveAccountId) == undefined;
}

export type UseIsGuest = typeof useIsGuest;
